import {
  HgLogoMash,
  type HgLogoMashProps,
} from '~/design-system/hg/components/HgLogoMash'
import LogoSVG from '~/cms/modules/_FEM/LogoMash/LogoSVG'
import {type SplitImageHeroModuleFragment} from '../../_generated/fragments.graphql'
import {HgBulletedList, HgTestimonial} from '~/design-system/hg/components'
import {SingleLineStructuredText} from '~/cms/components/SingleLineStructuredText'
import type {HgBulletedListProps} from '~/design-system/hg/components/HgBulletedList'

type AdditionalContentProps = {
  content: SplitImageHeroModuleFragment['additionalContent']
}

export function AdditionalContent({content}: AdditionalContentProps) {
  if (!content?.__typename) return null

  switch (content.__typename) {
    case 'LogoMashComponentRecord':
      return (
        <div className="flex-shrink-0 pt-s6 md:pt-0">
          <HgLogoMash
            logos={
              content.logos.map(({logo, captionText}) => ({
                logo: <LogoSVG logo={logo} />,
                companyName: logo.companyName,
                captionText,
              })) as HgLogoMashProps['logos']
            }
            logoSpacing="tighter"
          />
        </div>
      )
    case 'TestimonialCompactComponentRecord':
      return (
        <div className="mt-s6 border-t border-border-subdued md:mt-0 md:pt-0">
          <HgTestimonial
            topSpacing="s4"
            variant="compact"
            quote={<SingleLineStructuredText data={content.quote} />}
            firstName={<SingleLineStructuredText data={content.firstName} />}
            lastName={<SingleLineStructuredText data={content.lastName} />}
            company={<SingleLineStructuredText data={content.company} />}
            role={<SingleLineStructuredText data={content.role} />}
          />
        </div>
      )
    case 'BulletedListComponentRecord':
      return (
        <div className="mt-s6 border-t border-border-subdued">
          <HgBulletedList
            topPadding="s4"
            listItems={
              content.listItems.map(item => (
                <SingleLineStructuredText key={item.id} data={item} />
              )) as unknown as HgBulletedListProps['listItems']
            }
          />
        </div>
      )
    default:
      return null
  }
}
